// extracted by mini-css-extract-plugin
module.exports = {"accordion":"List_accordion__1-5L-","pagination":"List_pagination__ZCUG3"};